import { render, staticRenderFns } from "./noConformingProfitList.vue?vue&type=template&id=242dc299&scoped=true"
import script from "./noConformingProfitList.vue?vue&type=script&lang=js"
export * from "./noConformingProfitList.vue?vue&type=script&lang=js"
import style0 from "./noConformingProfitList.vue?vue&type=style&index=0&id=242dc299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242dc299",
  null
  
)

export default component.exports